module.exports = __webpack_public_path__ + "img/file.ff258197.svg";